"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogBody = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _focusMixin = require("../../mixins/focusMixin");
/**
 * A wrapper for `Dialog` body content
 * (content will automatically be wrapped when using the `body` prop).
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogBody = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "DialogBody",
  componentId: "c11n-8-107-0__sc-1l4a94i-0"
})(["", ""], function (props) {
  return (0, _focusMixin.focusMixin)(props);
});
exports.DialogBody = DialogBody;
DialogBody.displayName = 'DialogBody';

/** @component */